module.exports = {
	"actions": "Actions",
	"add": "Add",
	"amount": "Amount",
	"amount_plural": "Amounts",
	"authenticationIssue": "Authentication Issue. Please retry.",
	"authorizationRequiredFor": "Authorization Required",
	"backToTop": "Back to top",
	"bidder": "Bidder",
	"bidNow": "Bid now!",
	"brand": "Auctionex",
	"buyer": "Buyer",
	"by": "by",
	"cancel": "Cancel",
	"canceled": "Canceled",
	"cancelChanges": "Cancel changes",
	"cannotUndo": "This action cannot be undone.",
	"caution": "caution",
	"claimed": "Claimed",
	"close": "Close",
	"contact": {
		"addressLn1": "Address Line 1",
		"addressLn1Placeholder": "Street address or P.O. box",
		"addressLn2": "Address Line 2",
		"addressLn2Placeholder": "Apartement, suite, building, floor, etc.",
		"city": "City",
		"cityPlaceholder": "City name",
		"country": "Country",
		"countryPlaceholder": "Country name",
		"postalCode": "Postal or ZIP code",
		"postalCodePlaceholder": "Postal or ZIP code",
		"region": "Province/State/Region",
		"regionPlaceholder": "Province/State/Region name",
		"telephone": "Telephone",
		"telephonePlaceholder": "+1-514-700-2050",
		"website": "Website",
		"websitePlaceholder": "http://www.example.com"
	},
	"companyName": "Novivia",
	"companyNameInc": "$t(general::companyName) Inc.",
	"continue": "Continue",
	"creationDate": "Creation date",
	"database": "the database",
	"date": "Date",
	"day": "Day",
	"deny": "Deny",
	"description": "Description",
	"discardChanges": "Discard changes",
	"downgrade": "Downgrade",
	"downloadFileType": "Download __fileType__",
	"edit": "Edit",
	"end": "end",
	"error": "Error",
	"exportToPdf": "Export to PDF",
	"fullName": "Full name",
	"grant": "Grant",
	"here": "here",
	"ID": "ID",
	"increment_plural": "Increments",
	"increment": "Increment",
	"infinity": "Infinity",
	"infoUpdated": "Information successfully updated.",
	"informationDisplayedOnProfile": "This information will be displayed on your profile.",
	"insert": "Insert",
	"items": "items",
	"justNow": "Just now.",
	"language": "$t(language::name)",
	"learnMore": "Learn more",
	"left": "left",
	"loading": "Loading",
	"locale": "$t(language::code)",
	"loggedIn": "You need to be logged in.",
	"manageit": "You can now manage it.",
	"modificationsSaved": "Modifications saved.",
	"month": "Month",
	"monthly": "Monthly",
	"moreInformation": "More information",
	"name": "Name",
	"noDescription": "No description available.",
	"none": "None",
	"numberShort": "#",
	"or": "or",
	"outsideCanada": "Outside Canada",
	"payment": "Payment",
	"percentage": "Percentage",
	"periodFrom": "Period from",
	"periodTo": "$t(general::to)",
	"pleaseLogIn": "Please login or register",
	"pleaseLogInToContinue": "$t(general::pleaseLogIn) to continue",
	"pleaseTryAgain": "Please try again.",
	"poweredBy": "Powered by",
	"prebidding": "Pre-bidding",
	"preview": "This page is a preview only visible to you.",
	"price": "Price",
	"primary": "Primary",
	"quantity": "Quantity",
	"rank": "Rank",
	"rate": "Rate",
	"remove": "Remove",
	"retry": "Retry",
	"return": "Return",
	"saveChanges": "Save changes",
	"search": "Search",
	"seeDetails": "See details",
	"selfXss": "Do NOT paste anything here. There is a high chance someone is trying to steal your information or act under your name.",
	"seller": "Seller",
	"setDefault": "Set default",
	"shipping": "Shipping",
	"siteAddress": "auctionex.com",
	"siteName": "$t(general::brand)",
	"start": "start",
	"status": "Status",
	"submit": "Submit",
	"subTotal": "Subtotal",
	"success": "Success!",
	"switchTo": "Switch to __switchTo__",
	"taxes": "Taxes",
	"terms": "Terms",
	"to": "to",
	"total": "Total",
	"type": "Type",
	"unknown": "Unknown",
	"updateBtn": "Save modifications",
	"upgrade": "Upgrade",
	"userSubmitted": "Submitted by the user",
	"viewListing": "View listing",
	"warning": "Warning",
	"website": "the website",
	"year": "Year",
	"yearly": "Yearly",
	"you": "You"
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/en/general.json5
// module id = 1932
// module chunks = 6